import Column from '@amzn/meridian/column';
import Textarea from '@amzn/meridian/textarea';
import React from 'react';
import { Alert, useTranslation } from '../blocks';

export interface PatternTesterProps {
    value: string;
    onChange: (value: string) => void;
    emptyError?: boolean;
    exampleValidation?: { isValid: boolean; nonMatchingExamples?: string[] };
}

export const PatternTester: React.FC<PatternTesterProps> = ({ value, onChange, emptyError, exampleValidation }) => {
    const { t } = useTranslation('regexPatternModal');

    return (
        <Column spacing={'xsmall'} data-testid={'pattern-tester'}>
            <Textarea
                value={value}
                onChange={onChange}
                label={t('examples-fieldLabel')}
                rows={3}
                error={emptyError}
                data-testid={'pattern-tester-input'}
            />
            {emptyError && (
                <Alert type={'error'} size={'small'} data-testid={'regex-modal-examples-error'}>
                    {t('examplesRequired-fieldError')}
                </Alert>
            )}
            {exampleValidation && !exampleValidation.isValid && exampleValidation.nonMatchingExamples && (
                <Alert type={'error'} size={'small'} data-testid={'regex-modal-examples-error'}>
                    {t('nonMatchingExamples-fieldError', {
                        examples: exampleValidation.nonMatchingExamples.join(', '),
                    })}
                </Alert>
            )}
        </Column>
    );
};
